import { put, select, call, all } from 'redux-saga/effects';
import { actionSpinnerClose, actionSpinnerOpen } from '../actions';
import { apiAccountTypes, apiCountriesGet, apiDocumentTypes, apiUserTitlesGet } from '../api';
import { STATIC_VALUES_GET } from '../actions/types';
import {
  apiInstrumentsIndex,
  apiRandomWeights,
  apiRiskAppetiteProfiles,
  apiRiskProfilesTypes,
  apiMandateTypes,
  apiCrmOwners,
  apiInvestmentObjectiveTypes,
  apiFeeStructures,
  apiMaxDrawdownScenarios,
  apiAmlProfilesSectors,
  apiAmlProfilesOccupations,
  apiAmlProfilesSavingsOrigins,
} from '../api/statics';
import { createQadraSaga } from './shared';

function* staticsGet({ payload: { valueName, forced } }) {
  if (!forced) {
    // if the values are already stored, don't fetch anything
    const values = yield select((state) => state.statics[valueName]);
    if (values && (values.length > 0 || Object.keys(values).length > 0)) return;
  }

  try {
    if (!forced) yield put(actionSpinnerOpen());

    if (valueName === 'feeStructures') {
      const { feeStructures } = yield call(apiFeeStructures);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: feeStructures, valueName } });
    }

    if (valueName === 'userTitles') {
      const { titles } = yield call(apiUserTitlesGet);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: titles, valueName } });
    }

    if (valueName === 'countries') {
      const { countries } = yield call(apiCountriesGet);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: countries, valueName } });
    }

    if (valueName === 'documentTypes') {
      const { documentTypes } = yield call(apiDocumentTypes);
      documentTypes.sort((a, b) => (a.name > b.name ? 1 : -1));
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: documentTypes, valueName } });
    }

    if (valueName === 'accountTypes') {
      const { accountTypes } = yield call(apiAccountTypes);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: accountTypes, valueName } });
    }

    if (valueName === 'investmentObjectiveTypes') {
      const { investmentObjectiveTypes } = yield call(apiInvestmentObjectiveTypes);
      const sortedTypes = [
        investmentObjectiveTypes.find((t) => t.name === 'Expense'),
        investmentObjectiveTypes.find((t) => t.name === 'SafetyNet'),
        investmentObjectiveTypes.find((t) => t.name === 'Retirement'),
        investmentObjectiveTypes.find((t) => t.name === 'GenericInvestment'),
      ];
      yield put({
        type: STATIC_VALUES_GET._SUCCESS,
        payload: { data: sortedTypes, valueName },
      });
    }

    if (valueName === 'riskProfiles') {
      const { riskProfiles } = yield call(apiRiskProfilesTypes);
      riskProfiles.sort((a, b) => a.riskLevel - b.riskLevel);
      yield put({
        type: STATIC_VALUES_GET._SUCCESS,
        payload: { data: riskProfiles, valueName },
      });
    }

    if (valueName === 'mandateTypes') {
      const { types } = yield call(apiMandateTypes);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: types, valueName } });
    }

    if (valueName === 'instrumentsIndex') {
      const { instruments } = yield call(apiInstrumentsIndex);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: instruments, valueName } });
    }

    if (valueName === 'riskAppetiteProfiles') {
      const { riskAppetiteProfiles } = yield call(apiRiskAppetiteProfiles);

      yield put({
        type: STATIC_VALUES_GET._SUCCESS,
        payload: { data: riskAppetiteProfiles, valueName },
      });
    }

    if (valueName === 'randomWeights') {
      const { weights } = yield call(apiRandomWeights);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: weights, valueName } });
    }

    if (valueName === 'crmOwners') {
      const { results } = yield call(apiCrmOwners);
      yield put({ type: STATIC_VALUES_GET._SUCCESS, payload: { data: results, valueName } });
    }

    if (valueName === 'maxDrawdownScenarios') {
      const { maxDrawdownScenarios } = yield call(apiMaxDrawdownScenarios);
      yield put({
        type: STATIC_VALUES_GET._SUCCESS,
        payload: { data: maxDrawdownScenarios, valueName },
      });
    }

    if (valueName === 'amlProfilesProperties') {
      const results = yield all([
        call(apiAmlProfilesSectors),
        call(apiAmlProfilesOccupations),
        call(apiAmlProfilesSavingsOrigins),
      ]);
      const data = results.reduce((acc, res) => ({ ...acc, ...res }), {});

      yield put({
        type: STATIC_VALUES_GET._SUCCESS,
        payload: { data, valueName },
      });
    }
  } catch (error) {
    yield put({ type: STATIC_VALUES_GET._ERROR, error });
  } finally {
    if (!forced) yield put(actionSpinnerClose());
  }
}

const watchStaticsGet = createQadraSaga(staticsGet, {
  action: STATIC_VALUES_GET._REQUEST,
  hideSpinner: true,
  hideError: true,
});

export default [watchStaticsGet];
